/**
 * Created by nijin on 19/2/17.
 */
import {Component, OnInit, ViewChild, Input} from '@angular/core';
import {AppModalComponent} from "../../shared/modal/modal";

@Component({
    selector: 'nuc-preview-popup',
    templateUrl: './preview-popup.html',
    styleUrls: ['./preview-popup.scss']
})
export class PreviewPopup implements OnInit {
    @ViewChild('preview') preview;
    @Input() schema = {};
    @Input() eventData;
    isSubmitted: boolean;
     copied;
    constructor() { }

    ngOnInit() { }

    open(){
      this.copied = false;
      this.preview.open();
    }



}



// WEBPACK FOOTER //
// ./src/app/schema/shared/preview-popup.ts